import React from 'react'
import {
  Box,
  Card,
  Divider,
  Tab,
  Tabs,
  Avatar,
  Typography,
} from '@mui/material'
import { Link, useLocation, Outlet } from 'react-router-dom'
import { CustomerContextProvider, useCustomerContext } from './CustomerContext'
import { autonomyColor } from '../../global-styles/autonomyColor'
import { ResetLoginAttemptsButton } from './ResetLoginAttempts/ResetLoginAttemptsButton'
import { useTheme } from '../../utils/themeContext'
import { getColorsForTheme } from '../../global-styles/clientColors'
import { useEditCustomer } from './useEditCustomer'
import { FormDrawerComponent } from 'shared/FormDrawerComponent'
import { EditCustomer } from './EditCustomer'

const CustomerDetailsTabsWrapper = () => {
  const {
    customerId,
    customerName,
    recurringBillingDay,
    customerInfo: currentCustomer,
    clientId,
  } = useCustomerContext()

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  const {
    updateCustomer,
    isEditCustomerModalOpen,
    setIsEditCustomerModalOpen,
  } = useEditCustomer()
  const { pathname } = useLocation()

  const handleClickOpen = () => {
    // Empty function for onClick event
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          p: 3,
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'background.default',
            p: 3,
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <Avatar
              src={''}
              sx={{
                height: 42,
                width: 42,
              }}
              onClick={() => {
                setIsEditCustomerModalOpen(true)
              }}
            />
            <Box sx={{ ml: 1 }}>
              <Typography
                sx={{ fontSize: 25 }}
                color="inherit"
                variant="subtitle2"
              >
                {customerName}
              </Typography>
              <Typography color={autonomyColor.white} variant="body2">
                {/*todo: make this more dynamic especially if more clients are added*/
                  clientId == '613e89a2-2a57-4050-9b7e-eda0a1bf94a7' ? 'Galpin Customer' : 'Autonomy Customer'}
              </Typography>
              <Typography color={autonomyColor.white} variant="body2">
                customer_id: {customerId}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            {recurringBillingDay != 0 && (
              <Box
                sx={{ ml: 1, marginRight: '60px' }}
                onClick={handleClickOpen}
              >
                <Typography color={autonomyColor.pink} variant="overline">
                  Recurring Billing Day
                </Typography>
                <Typography variant="h4" align={'center'}>
                  {recurringBillingDay}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Card>
        <Tabs sx={{ px: 3 }} value={pathname}>
          <Tab
            component={Link}
            label={'Details'}
            value={`/customers/${customerId}`}
            to={`/customers/${customerId}`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
          <Tab
            component={Link}
            label={'Invoices'}
            value={`/customers/${customerId}/invoices`}
            to={`/customers/${customerId}/invoices`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
          <Tab
            component={Link}
            label={'CQE'}
            value={`/customers/${customerId}/cqe`}
            to={`/customers/${customerId}/cqe`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
          <Tab
            component={Link}
            label={'Mileage'}
            value={`/customers/${customerId}/mileage`}
            to={`/customers/${customerId}/mileage`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
          <Tab
            component={Link}
            label={'Documents'}
            value={`/customers/${customerId}/documents`}
            to={`/customers/${customerId}/documents`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
          <Tab
            component={Link}
            label={'Insurance'}
            value={`/customers/${customerId}/insurance`}
            to={`/customers/${customerId}/insurance`}
            sx={{
              color: themeColors.buttonColor,
              '&.Mui-selected': {
                color: themeColors.buttonColor,
              },
            }}
          />
        </Tabs>

        <Divider />
        <Outlet/>
      </Card>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: 3,
          marginBottom: 5,
        }}
      >
        <ResetLoginAttemptsButton />
      </Box>
      {isEditCustomerModalOpen && (
        <FormDrawerComponent
          isDrawerOpen={isEditCustomerModalOpen}
          setIsDrawerOpen={setIsEditCustomerModalOpen}
          header={'Edit Customer'}
          handleSave={updateCustomer}
          defaultValues={currentCustomer}
          form={({ errors, control }) => {
            return <EditCustomer errors={errors} control={control} />
          }}
        />
      )}
    </>
  )
}

export const CustomerDetailsPage = () => {
  return (
    <CustomerContextProvider>
      <CustomerDetailsTabsWrapper />
    </CustomerContextProvider>
  )
}
